export default __webpack_public_path__ + "static/media/team43.d8db2ad5.JPG";